module.exports = __webpack_public_path__ + "static/media/cab-q17.5ea3f303.jpg";